/**
 * Ezen fájl alapján kell létrehozni egy config.js-t,
 * ugyanitt az src/config mappában
 * @type {string}
 */
export const BASE_URL = 'https://cmsapi.tmx.hu';
export const CRM_URL = 'https://mobilfutarapi.tmx.hu';
export const SAMPLE = '';
